import React, { useState, useEffect, useCallback } from "react";
import { Search } from "lucide-react";
import "./SearchBar.css";

export default function SearchBar({
  value,
  onChange,
  placeholder = "Search...",
  debounceMs = 300,
}) {
  const [localValue, setLocalValue] = useState(value || "");

  // Update local value when prop value changes
  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  // Debounced onChange handler
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onChange && localValue !== value) {
        onChange(localValue);
      }
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [localValue, debounceMs, onChange, value]);

  const handleChange = useCallback((e) => {
    setLocalValue(e.target.value);
  }, []);

  const handleClear = useCallback(() => {
    setLocalValue("");
    if (onChange) {
      onChange("");
    }
  }, [onChange]);

  return (
    <div className="search-bar-wrapper">
      <div className="search-bar-icon">
        <Search size={18} />
      </div>
      <input
        type="text"
        className="search-bar-input"
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
      />
      {localValue && (
        <button
          type="button"
          className="search-bar-clear"
          onClick={handleClear}
          aria-label="Clear search"
        >
          ×
        </button>
      )}
    </div>
  );
}
